import { render, staticRenderFns } from "./VideoModal.vue?vue&type=template&id=5fa0d36a&lang=pug"
import script from "./VideoModal.vue?vue&type=script&lang=js"
export * from "./VideoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports